import React from 'react';

import classNames from 'classnames';

import { CTA_COLORS } from '@/components/common/types';

import {
  BUTTON_SIZE_CLASSES,
  BUTTON_SIZES,
  BUTTON_STYLE_CLASSES,
  BUTTON_STYLES,
} from '@/components/ui/Buttons/utils';

import Spinner from '@/components/ui/Icons/Spinner';

import {
  ExperimentSelectors,
  getCTAStyles,
  getExperimentSelectorsAttributes,
} from '@/components/utils';

export interface ButtonProps {
  ctaText: string | undefined;
  ctaColor?: CTA_COLORS;
  onClick?:
    | ((event?: React.MouseEvent<HTMLButtonElement>) => void)
    | (() => void);
  classes?: string;
  id?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: BUTTON_SIZES;
  style?: BUTTON_STYLES;
  fullWidth?: boolean;
  form?: string;
  testId?: string;
  includeSpinner?: boolean;
  experimentSelectors?: ExperimentSelectors;
}

const Button = ({
  ctaText = '',
  ctaColor = CTA_COLORS.DEFAULT,
  onClick = () => null,
  classes = '',
  id,
  disabled = false,
  type = 'button',
  size = BUTTON_SIZES.md,
  style = BUTTON_STYLES.primary,
  fullWidth = false,
  form,
  testId,
  includeSpinner = false,
  experimentSelectors,
}: ButtonProps) => (
  <button
    className={classNames(
      BUTTON_STYLE_CLASSES[style],
      BUTTON_SIZE_CLASSES[size],
      classes,
      {
        'w-full': fullWidth,
        [getCTAStyles(ctaColor)]: style === BUTTON_STYLES.primary,
      },
    )}
    type={type}
    onClick={onClick}
    id={id}
    disabled={disabled}
    form={form}
    data-testid={testId}
    {...getExperimentSelectorsAttributes(experimentSelectors)}
  >
    {ctaText}

    {includeSpinner && <Spinner />}
  </button>
);

export default React.memo(Button);
